var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "l-map",
        {
          staticStyle: { height: "50vh" },
          attrs: { zoom: _vm.zoom, center: _vm.center },
        },
        [
          _c("l-tile-layer", { attrs: { url: _vm.url } }),
          _vm._v(" "),
          _vm._l(this.rectangles, function (rectangle) {
            return _c("l-rectangle", {
              key: rectangle.name,
              attrs: {
                name: rectangle.name,
                bounds: rectangle.bounds,
                color: rectangle.style.color,
                weight: rectangle.style.weight,
                dashOffset: rectangle.style.dashOffset,
                dashArray: rectangle.style.dashArray,
                fill: rectangle.style.fill,
              },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }